module.exports = __webpack_public_path__ + "img/User.340ce980.svg";